import React from 'react';
import cn from 'classnames';
import { getTaskWrapperStyle } from '../utils';
import TaskWithPopover from '../../TaskWithPopover/TaskWithPopover';
import Task from '../../Task/Task';
import { containerIds } from '../../../constants/containerIds';
import { cellHeight } from '../../../constants/common';
import commonStyles from '../../../Calendar.module.scss';
import styles from '../CalendarGrid.module.scss';
import { modes } from '../../../constants/modes';
import { views } from '../../../constants/views';
import { useCalendarState } from '../../../context/CalendarContext';

const DayTaskWrapper = ({
  day,
  task,
  taskIndex,
  taskCount,
  taskWrapperWidth,
}) => {
  const { view, mode, showOwner, calendarData } = useCalendarState();

  const heightTask = showOwner && mode === modes.calendar && view === views.day;

  const wrapperStyle = getTaskWrapperStyle(
    task,
    day,
    taskIndex,
    taskCount,
    taskWrapperWidth,
    heightTask,
    calendarData
  );

  const { height } = wrapperStyle;

  const heightNum = height.replace(/[^0-9\.]/g, '');

  const reshape = heightNum < cellHeight(heightTask, calendarData);

  const taskProps = {
    task,
    style: {
      width: '100%',
      justifyContent: reshape ? 'center' : 'start',
    },
    withShadow: true,
    hideWorkers: reshape,
    inline: reshape,
    getPopupContainer: () => document.getElementById(containerIds.calendarGrid),
  };

  return (
    <div className={styles.dayTaskWrapper} style={wrapperStyle}>
      {task.withPopover ? (
        <TaskWithPopover {...taskProps} />
      ) : (
        <Task
          rootClassName={cn(commonStyles[`checkbox-${task.index}`], 'task')}
          {...taskProps}
        />
      )}
    </div>
  );
};

export default DayTaskWrapper;
